import { MealsFullscreen } from "../Dialogs/FullscreenDlg";
import Validators from "../../gui/Form/Validators";
import FormControl from "../../gui/Form/FormControl";
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput";
import { useEffect, useRef, useState } from "react";
import Button from "../../gui/Button/Button";
import AddIcon from "../../gui/Icons/AddIcon";
import MealRow from "./MealRow";
import { TFoodEntry } from "../../shared/Meals";
import _ from "lodash"

export default function MealEditor(){
    const {item, update} = MealsFullscreen.useFullscreen()
    const [items,setFoods] = useState<TFoodEntry[]>(item.foods.slice(0))
    const nameRef = useRef<ITextInput|null>(null)
    const mounted = useRef<boolean>(false)

    useEffect(() => {
        if (mounted.current) onChange()
        else mounted.current = true
    }, [items, item])

    const onChange = () => {
        const dirty = item.name!=nameRef.current?.value || !_.isEqual(item.foods, items)
        const valid = !!nameRef.current?.value && !items.find(i => !i.id || !i.amount)
        update(dirty, valid, {
            name:nameRef.current?.value,
            foods:items
        })
    }
    const onAdd = () => setFoods(foods => {
        const list = foods.slice(0)
        list.push({id:0,amount:0,unit:"g"})
        return list
    })

    const onUpdate = (index:number, entry:TFoodEntry) => {
        setFoods(foods => {
            foods[index] = entry
            return foods.slice(0)
        })
    }

    const onDelete = (index:number) => {
        setFoods(foods => {
            foods.splice(index,1)
            return foods.slice(0)
        })
    }

    const rows = items.map( (food,i) => <MealRow index={i} entry={food} key={i.toString()+":"+food.id} onUpdate={onUpdate} onDelete={onDelete}/> )
    return <div className="mealEditor flex vert gap-24">
        <FormControl className="flex1" validators={[Validators.Required("Name")]}>
            <TextInput placeholder="Name" float={true} defaultValue={item.name} ref={nameRef} onUpdate={onChange}/>
        </FormControl>
        <div className="foodList">
            {rows}
            <Button className="colspan" onClick={onAdd}><AddIcon/> Add Food/Recipe</Button>
        </div>
    </div>
}